import { Button } from 'ii-react-sdk/form_components';
import React, { useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useContentLibrary } from '../../../providers/content_library_provider';
import DocumentResult from './documentResult';
const DocumentSearchTable = ({ documents, queryInfo }) => {
    const { getMoreDocuments, selectedDocuments, selectManyDocuments, toggleSelectedDocument, performSearch, } = useContentLibrary();
    const [allDocsSelected, setAllDocsSelected] = useState(false);
    const [tableData, setTableData] = useState([]);
    useEffect(() => {
        if (documents.length > 0) {
            setTableData(documents);
        }
    }, [documents]);
    useEffect(() => {
        setAllDocsSelected(documents.every(doc => selectedDocuments.find(sd => sd.id === doc.fileId)));
    }, [selectedDocuments, documents]);
    const handleSelectAllDocuments = () => {
        if (!allDocsSelected) {
            const docsToAdd = documents.filter(doc => !selectedDocuments.find(sd => sd.id === doc.fileId)).map(doc => {
                return { id: doc.fileId, name: doc.fileName, txId: doc.txId, docType: doc.docType };
            });
            selectManyDocuments(docsToAdd, false);
        }
        else {
            const docsToRemove = documents.map(doc => {
                return { id: doc.fileId, name: doc.fileName, txId: doc.txId, docType: doc.docType };
            });
            selectManyDocuments(docsToRemove, true);
        }
    };
    const handleSelectDocument = (doc) => {
        toggleSelectedDocument({ id: doc.fileId, name: doc.fileName, txId: doc.txId, docType: doc.docType });
    };
    return (React.createElement("div", { className: 'document-search-results' },
        React.createElement("div", { className: 'document-results-header', "data-public": true },
            React.createElement("div", { className: 'results-count' },
                "Document Results ",
                React.createElement("b", null,
                    "(",
                    documents.length,
                    ")")),
            React.createElement(Button, { className: 'refresh-btn plain', onClick: performSearch },
                React.createElement("div", { key: 'still' },
                    React.createElement("i", { className: 'far fa-sync' })))),
        React.createElement("div", { className: 'results-table-header', "data-public": true },
            React.createElement("h5", { className: 'check-col' },
                React.createElement("input", { id: 'select-all-documents', type: 'checkbox', className: 'input', checked: allDocsSelected, onChange: handleSelectAllDocuments })),
            React.createElement("h5", { className: 'doc-col' }, "Document Name"),
            React.createElement("h5", { className: 'status-col' }, "Status"),
            React.createElement("h5", { className: 'time-col' }, "Submission Time")),
        React.createElement("div", { className: 'results-table-items', id: 'scrollable-results' },
            React.createElement(InfiniteScroll, { dataLength: tableData.length, next: getMoreDocuments, hasMore: queryInfo.documentsFetched < queryInfo.totalDocuments, loader: React.createElement("div", { className: 'loading-results', "data-public": true }, "Loading More Documents..."), scrollableTarget: 'scrollable-results' }, tableData.map(doc => {
                const selected = !!(selectedDocuments.find(sd => sd.id === doc.fileId));
                return React.createElement(DocumentResult, { key: doc.fileId, doc: doc, selected: selected, handleSelectDocument: handleSelectDocument });
            })))));
};
export default DocumentSearchTable;
